<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter"><section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Lord"><h1 class="chapter2" id="pz12-1"><a href="#/contents#ba_02a" id="ab_02a"><b>Lord</b></a></h1>
<p id="pz12-3">Therefore God also has highly exalted Him and given Him the name which is above every name,</p>
<p id="pz12-4">that at the name of Jesus every knee should bow, of those in heaven, and of those on earth, and of those under the earth,</p>
<p id="pz12-5">and that every tongue should confess that Jesus Christ is Lord, to the glory of God the Father.</p>
<p class="right" id="pz12-6"><em>Philippians 2:9–11</em></p>
<p id="pz12-7">That if you confess with your mouth the Lord Jesus and believe in your heart that God has raised Him from the dead, you will be saved.</p>
<p id="pz12-8">For with the heart one believes unto righteousness, and with the mouth confession is made unto salvation.</p>
<p class="right" id="pz12-9"><em>Romans 10:9, 10</em></p>
<p id="pz12-10">But why do you call Me “Lord, Lord,” and not do the things which I say?</p>
<p class="right" id="pz12-12"><em>Luke 6:46</em></p>
<p id="pz12-13">For sin shall not have dominion over you, for you are not under law but under grace.</p>
<p id="pz13-1">What then? Shall we sin because we are not under law but under grace? Certainly not!</p>
<p id="pz13-2">Do you not know that to whom you present yourselves slaves to obey, you are that one’s slaves whom you obey, whether of sin leading to death, or of obedience leading to righteousness?</p>
<p class="right" id="A7C"><em>Romans 6:14–16</em></p>
<p id="pz13-3">I beseech you therefore, brethren, by the mercies of God, that you present your bodies a living sacrifice, holy, acceptable to God, which is your reasonable service.</p>
<p id="pz13-4">And do not be conformed to this world, but be transformed by the renewing of your mind, that you may prove what is that good and acceptable and perfect will of God.</p>
<p class="right" id="pz13-5"><em>Romans 12:1, 2</em></p>
<p id="pz13-6">Or do you not know that your body is the temple of the Holy Spirit who is in you, whom you have from God, and you are not your own?</p>
<p id="pz13-7">For you were bought at a price; therefore glorify God in your body and in your spirit, which are God’s.</p>
<p class="right" id="pz13-8"><em>I Corinthians 6:19, 20</em></p>
<p id="pz14-1">Therefore let all the house of Israel know assuredly that God has made this Jesus, whom you crucified, both Lord and Christ.</p>
<p class="right" id="pz14-2"><em>Acts 2:36</em></p>
<p id="pz14-3">For if we live, we live to the Lord; and if we die, we die to the Lord. Therefore, whether we live or die, we are the Lord’s.</p>
<p class="right" id="pz14-4"><em>Romans 14:8</em></p>
<p id="pz14-5">Blessed be the Lord,</p>
<p id="pz14-6">Who daily loads us with benefits,</p>
<p id="pz14-7">The God of our salvation! Selah</p>
<p class="right" id="pz14-8"><em>Psalm 68:19</em></p>
<p id="pz14-9">But it is good for me to draw near to God;</p>
<p id="pz14-10">I have put my trust in the Lord G<span class="smallcaps">OD</span>,</p>
<p id="pz14-11">That I may declare all your works.</p>
<p class="right" id="pz14-12"><em>Psalm 73:28</em></p>
<p id="pz14-13">For You, Lord, are good, and ready to forgive,</p>
<p id="Anm">And abundant in mercy to all those who call upon You.</p>
<p class="right" id="pz14-15"><em>Psalm 86:5</em></p>
<p id="pz14-16">For the Lord G<span class="smallcaps">OD</span> will help Me; therefore I will not be disgraced; therefore I have set My face like a flint, and I know that I will not be ashamed.</p>
<p class="right" id="AP8R"><em>Isaiah 50:7</em></p>
<p id="pz15-1">And you shall love the L<span class="smallcaps">ORD</span> your God with all your heart, with all your soul, with all your mind, and with all your strength. This is the first commandment.</p>
<p class="right" id="pz15-2"><em>Mark 12:30</em></p>
<p id="pz15-3">For David says concerning Him:</p>
<p id="pz15-4">“I foresaw the L<span class="smallcaps">ORD</span> always before my face,</p>
<p id="pz15-5">For He is at my right hand, that I may not be shaken.”</p>
<p class="right1" id="pz15-7"><em>Acts 2:25</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter02a.vue?1d8ee888